import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import AppearWrapper from '@Components/Animation/AppearWrapper';
import DropdownContentWrapper from './DropdownContentWrapper';
import DropdownCloseButton from './DropdownCloseButton';

import withOpenCloseStuff from '@Hooks/withOpenCloseStuff';

import './Dropdown.custom.scss';
import './Dropdown.theme.scss';

export const dropdownMainClassName = 'new-dropdown';

export class Dropdown extends React.PureComponent {
  render () {
    const {
      isOpen,
      content,
      children,
      className,
      closeButton,
      horizontalAlignment,
      contentWrapperClassName,
    } = this.props;

    return (
      <div className={classnames(className, dropdownMainClassName, {
        ['new-dropdown-opened']: isOpen,
      })}>
        <div className='new-dropdown-toggler-wrapper'>
          {children({
            ...this.props
          })}
        </div>

        <AppearWrapper isOpen={isOpen}>
          <DropdownContentWrapper
            horizontalAlignment={horizontalAlignment}
            className={contentWrapperClassName}
          >
            <DropdownCloseButton
              {...this.props}
              closeButton={closeButton}
            />
            {content({
              ...this.props
            })}
          </DropdownContentWrapper>
        </AppearWrapper>
      </div>
    );
  }
}

Dropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  horizontalAlignment: PropTypes.string,
  contentWrapperClassName: PropTypes.string,
};

export const openCloseStaffSpec = {
  closeOnClick: ({ target }) => {
    return !target.closest(`.${dropdownMainClassName}`);
  },
};

export default withOpenCloseStuff(openCloseStaffSpec)(Dropdown);
